export interface TrackPoint {
  coordinates: { lat: number; lon: number };
}

export function fitPoints(track: TrackPoint[]): [number, number][] {
  return track.map((point) => [point.coordinates.lat, point.coordinates.lon]);
}

export function getMapFitPositions(
  flightTrack: TrackPoint[],
  upTrack: TrackPoint[],
): [number, number][] {
  if (flightTrack.length) {
    return fitPoints(flightTrack);
  }

  return fitPoints(upTrack);
}
